export default __webpack_public_path__ + "static/media/bannerMW.0fba4be7.webp";